import { v4 as uuid } from 'uuid';
const createAccount = (partialAccount = {}) => ({
    accountId: { value: uuid() },
    accountNumber: { value: '12345678910' },
    alias: 'Spending account',
    balance: { accountingBalance: 10000, availableBalance: 10000, creditLimit: 0 },
    bank: { bankregnr: { value: '0770' } },
    coreProduct: '',
    currency: 'NOK',
    favorite: true,
    owners: [],
    rights: { paymentFrom: false, transferFrom: false, transferTo: false },
    status: 'UNKNOWN',
    type: 'CLIENT_ACCOUNT',
    additionalInfo: {},
    ...partialAccount,
});
export const favoriteAccount = createAccount({
    alias: 'Spending account',
});
const createEFakturaData = (partial = {}) => ({
    amount: 200,
    issuerName: 'Elkjop.no',
    kid: { value: '1254585' },
    fromAccount: favoriteAccount.accountNumber,
    toAccountNumber: { value: '12345452' },
    eFakturaReference: '123456',
    permission: {
        canEdit: false,
        canView: false,
        canReject: false,
    },
    issuerId: '1234567',
    agreementId: { value: '1234' },
    minimumAmount: 123,
    efakturaType: 'EFAKTURA',
    currency: 'NOK',
    id: { value: '12345678' },
    paymentDate: '2025-09-28',
    notificationDate: '2024-12-23',
    status: 'NEW',
    ...partial,
});
export const visibleAccounts = [
    favoriteAccount,
    createAccount({
        alias: 'Savings account',
        balance: { accountingBalance: 124548, availableBalance: 124548, creditLimit: 0 },
        accountNumber: { value: '1234565432' },
    }),
];
export const transactions = [
    {
        id: '123',
        label: 'April 2021',
        transactions: [
            {
                id: '1231',
                description: 'Apple Store',
                date: '30.04.21',
                amount: '16 990,00',
                deposit: false,
                reservation: true,
            },
        ],
    },
    {
        id: '124',
        label: 'March',
        transactions: [
            {
                id: '1231',
                description: 'Pepsi and a burger',
                date: '12.03.21',
                amount: '1 024,00',
                deposit: false,
                reservation: false,
            },
            {
                id: '1232',
                description: 'Eika Gruppen',
                date: '01.03.21',
                amount: '42 0012,00',
                deposit: true,
                reservation: false,
            },
            {
                id: '1233',
                description: 'Apple Store',
                date: '01.03.21',
                amount: '1 990,00',
                deposit: false,
                reservation: false,
            },
        ],
    },
];
export const eFakturas = [createEFakturaData()];
//# sourceMappingURL=data:application/json;base64,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